import { useTranslation } from "react-i18next";
import { Business, Home } from "../../../Assets/Icons";
import { HomeHeaderNavs, IHomeHeaderNavItems } from "../../../Interfaces/componentTypes";

const useHomeHeader = ()=>{
const {t} = useTranslation();

    const homeNavs: IHomeHeaderNavItems = [
        {
            title: t('Home.Header.Home'),
            id: HomeHeaderNavs.Home,
            icon: Home
        },
        {
            title: t('Home.Header.Business_dashboard'),
            id: HomeHeaderNavs.Business,
            icon: Business
        },
    ];

    return {
        homeNavs
    }
};

export default useHomeHeader